<template>
  <v-container>
    <!-- Banner promocional (grupo por cantidad y/o forma de pago) -->
    <promo-banner :grupo-id="grupoIdProductos"></promo-banner>

    <v-row class="mt-4" v-show="!loading">
      <v-col v-for="(p,i) in localProducts" :key="`product_${i}`" cols="3">
        <product-card :product="p" :categoria-disponible="categoriaDisponible"></product-card>
      </v-col>
    </v-row>
    <v-row class="mt-4" v-if="loading">
      <v-col v-for="i in 8" cols="3" :key="`${i}ab`">
        <v-skeleton-loader
            type="image, actions"
            :loading="loading">
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import ProductCard from '@/components/cards/ProductCard.vue'
import PromoBanner from '@/components/PromoBanner.vue'

export default {
  components: { ProductCard, PromoBanner },
  name: 'ProductListHome',
  props: {
    categoriaId: {
      type: Number
    },
    categoria: {
      type: Object,
      default: null
    }
  },
  computed: {
    categoriaDisponible () {
      if (!this.categoria) return true
      return this.$store.getters['Categorias/categoriaDisponible'](this.categoria)
    },
    grupoIdProductos () {
      // Obtener el GrupoId del primer producto que tenga GrupoDescuento
      if (this.localProducts && this.localProducts.length > 0) {
        const productoConGrupo = this.localProducts.find(p => p.GrupoDescuento && p.GrupoDescuento.GrupoId)
        return productoConGrupo ? productoConGrupo.GrupoDescuento.GrupoId : null
      }
      return null
    }
  },
  methods: {
    ...mapActions('Productos', ['fetchProducts']),
    emitLoaded () {
      this.$emit('products-loaded', (this.localProducts && this.localProducts.length) || 0)
    }
  },
  watch: {
    '$route.params.client': {
      handler: async function (newClient, oldClient) {
        if (newClient && newClient !== oldClient && this.categoriaId) {
          this.loading = true
          this.localProducts = await this.fetchProducts(this.categoriaId)
          this.loading = false
          this.emitLoaded()
        }
      },
      immediate: false
    },
    categoriaId: {
      handler: async function (newId, oldId) {
        if (newId && newId !== oldId) {
          this.loading = true
          this.localProducts = await this.fetchProducts(newId)
          this.loading = false
          this.emitLoaded()
        }
      },
      immediate: false
    }
  },
  async mounted () {
    this.loading = true
    this.localProducts = await this.fetchProducts(this.categoriaId)
    this.loading = false
    this.emitLoaded()
  },
  data () {
    return {
      loading: false,
      localProducts: []
    }
  }
}
</script>
